var ConfiguracaoMapa = /** @class */ (function () {
    function ConfiguracaoMapa(latitudeCidade, longitudeCidade, zoomMapaCidade) {
        this.latitudeCidade = latitudeCidade;
        this.longitudeCidade = longitudeCidade;
        this.zoomMapaCidade = zoomMapaCidade;
    }
    return ConfiguracaoMapa;
}());
export { ConfiguracaoMapa };
